import {
  IAutoInsuranceExtractionResponse,
  IBusinessCardExtractionResponse,
  IDriversLicenseExtractionResponse,
  IResumeExtractionResponse
} from "@wingspanhq/shared-files/dist/lib/constants/extractions";
import {
  SharedFileRequest,
  SharedFileRequestJobType
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsSharedFileAutoInsuranceContext } from "./selectorIsSharedFileAutoInsuranceContext";
import { selectorIsSharedFileBusinessCardContext } from "./selectorIsSharedFileBusinessCardContext";
import { selectorIsSharedFileDriversLicenseContext } from "./selectorIsSharedFileDriversLicenseContext";
import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";
import { selectorIsSharedFileResumeContext } from "./selectorIsSharedFileResumeContext";

/**
 * The v1 shared-files SDK typed extraction results per context
 * (drivers-license/business-card/resume/auto-insurance). v3's
 * `SharedFileRequestJob.extractedFields` is a generic string-keyed map with
 * no per-context SDK equivalent, so the cast from the generic map to the
 * known shape is preserved here rather than invented.
 */
export function selectorSharedFileExtractedFields(
  sharedFile: SharedFileRequest | undefined
):
  | IDriversLicenseExtractionResponse
  | IBusinessCardExtractionResponse
  | IResumeExtractionResponse
  | IAutoInsuranceExtractionResponse
  | undefined {
  if (!selectorIsSharedFileNotNoneContext(sharedFile?.contextType)) {
    return undefined;
  }

  let extractedFields:
    | IDriversLicenseExtractionResponse
    | IBusinessCardExtractionResponse
    | IResumeExtractionResponse
    | IAutoInsuranceExtractionResponse
    | undefined;

  if (selectorIsSharedFileDriversLicenseContext(sharedFile?.contextType)) {
    extractedFields = sharedFile?.jobs
      ?.filter(job => job.type === SharedFileRequestJobType.EXTRACTION)
      .reduce((acc, job) => {
        const extractedFields =
          job.extractedFields as IDriversLicenseExtractionResponse;

        return { ...acc, ...extractedFields };
      }, {} as IDriversLicenseExtractionResponse);
  } else if (selectorIsSharedFileBusinessCardContext(sharedFile?.contextType)) {
    extractedFields = sharedFile?.jobs
      ?.filter(job => job.type === SharedFileRequestJobType.EXTRACTION)
      .reduce((acc, job) => {
        const extractedFields =
          job.extractedFields as IBusinessCardExtractionResponse;

        return { ...acc, ...extractedFields };
      }, {} as IBusinessCardExtractionResponse);
  } else if (selectorIsSharedFileResumeContext(sharedFile?.contextType)) {
    extractedFields = sharedFile?.jobs
      ?.filter(job => job.type === SharedFileRequestJobType.EXTRACTION)
      .reduce((acc, job) => {
        const extractedFields =
          job.extractedFields as IResumeExtractionResponse;

        return { ...acc, ...extractedFields };
      }, {} as IResumeExtractionResponse);
  } else if (
    selectorIsSharedFileAutoInsuranceContext(sharedFile?.contextType)
  ) {
    extractedFields = sharedFile?.jobs
      ?.filter(job => job.type === SharedFileRequestJobType.EXTRACTION)
      .reduce((acc, job) => {
        const extractedFields =
          job.extractedFields as IAutoInsuranceExtractionResponse;

        return { ...acc, ...extractedFields };
      }, {} as IAutoInsuranceExtractionResponse);
  }

  return extractedFields && Object.keys(extractedFields).length > 0
    ? extractedFields
    : undefined;
}
